import { Link } from "react-router-dom";
import { Reveal } from "@/components/Reveal";

const partners = [
  {
    id: "private-gp",
    no: "P.01",
    title: "Private GP & Independent Healthcare",
    body: "Bring cardiac diagnostics directly to your practice. Dedicated echocardiography and diagnostic sessions delivered within your own clinical environment — CVI provides the equipment and specialist expertise.",
  },
  {
    id: "nhs",
    no: "P.02",
    title: "NHS Primary Care & PCNs",
    body: "Flexible diagnostic capacity for GP practices, Primary Care Networks and NHS organisations — configured around local pathways, with governance, escalation and quality assurance agreed before commencement.",
  },
  {
    id: "research",
    no: "P.03",
    title: "Clinical Research & Research Echo",
    body: "Protocol-specific echocardiography and cardiovascular monitoring for NIHR/CRN teams, universities, CROs and sponsors — consistent, reproducible, study-ready imaging datasets.",
  },
];

export const Partnerships = () => (
  <section id="partnerships" className="bg-ivory paper-grain py-28 lg:py-36" data-testid="partnerships-section">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <Reveal>
        <p className="font-mono text-[11px] tracking-[0.35em] uppercase text-gold mb-4">
          Who We Work With
        </p>
        <h2 className="font-serif text-2xl sm:text-3xl lg:text-4xl font-semibold text-navy max-w-2xl leading-tight">
          Diagnostics delivered in partnership — not at arm's length.
        </h2>
      </Reveal>

      <div className="mt-20 space-y-px bg-navy/10 border border-navy/10">
        {partners.map((p, i) => (
          <Reveal key={p.id} delay={i * 0.1} className="bg-ivory">
            <div
              className="grid lg:grid-cols-12 gap-6 items-center p-10 lg:p-14 group hover:bg-navy transition-colors duration-500"
              data-testid={`partner-card-${p.id}`}
            >
              <p className="lg:col-span-2 font-mono text-xs tracking-[0.3em] text-gold">
                {p.no} /
              </p>
              <h3 className="lg:col-span-4 font-serif text-2xl lg:text-3xl font-semibold text-navy group-hover:text-ivory transition-colors duration-500">
                {p.title}
              </h3>
              <div className="lg:col-span-6">
                <p className="text-sm leading-relaxed text-navy/60 group-hover:text-ivory/70 transition-colors duration-500">
                  {p.body}
                </p>
                {p.id === "private-gp" && (
                  <Link
                    to="/private-gp"
                    data-testid="partner-card-readmore"
                    className="inline-block mt-4 font-mono text-[10px] tracking-[0.25em] uppercase text-gold hover:text-champagne transition-colors"
                  >
                    Read More →
                  </Link>
                )}
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
